import { MenuItems } from "Utils/Constants/MenuItems";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { changePage } from "../../../../Redux/slices/globalSlice";
import { HandleLoading } from "Utils/Helpers/HandleLoading";
import { HandleLogOut } from "Utils/Helpers/HandleLogin";
import { useEffect, useState } from "react";
import { HandleVibrate } from "Utils/Helpers/HandleApiData";

export default function MenuDrawer({ setClose, setLoading }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [menu, setMenu] = useState([]);
    const { page, current } = useSelector((state) => ({
        page: state.setting.page,
        current: state.staff.current,
    }));
    
    useEffect(() => {
        if(current) {
            let _new = []
            MenuItems.map(item => {
                return _new.push({
                    title: item.title,
                    icon: item.icon,
                    action: item.action,
                    active: item.active ? item.acin === 0 ? true : current[item.acin[0]][item.acin[1]] : false,
                    pageIndex: item.pageIndex,
                })
            })
            setMenu(_new);
        }
    }, [current])
    
    const handlePush = (e, item) => {
        try{
            setClose()
        } catch{}
        dispatch(HandleLoading(true));
        if(item.pageIndex !== 3) dispatch(changePage(item.pageIndex));
        else dispatch(HandleLogOut());
        navigate(item.action);
        dispatch(HandleLoading(false));
    }
    const onMouseUp = (e) => {
        HandleVibrate();
    }
    return (
        <div className='menu'>
            <ul>
                {
                    menu.filter(item => item.active !== false).map(item => {
                        return(
                            <li
                                key={`menuItems-${item.title}`}
                                onClick={(e) => handlePush(e, item)}
                                onMouseUp={onMouseUp}
                                className={page === item.pageIndex ? 'active' : ''}
                            >
                                <div>
                                    {item.icon}
                                </div>
                                <p>{item.title}</p>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    );
}